(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ViteBifrost", [], factory);
	else if(typeof exports === 'object')
		exports["ViteBifrost"] = factory();
	else
		root["ViteBifrost"] = factory();
})(this, function() {
return 